<script type="text/ecmascript-6">
    export default {
        props: {
            node: Object,
            label: String,
            childrenCollapsed: false,
            selected: Array,
            hidden: Array,
            showCounts: false,
        },
        computed: {
            nodeWithoutLabel() {
                if (_.trim(this.label).length > 0) {
                    return false;
                }

                return _.trim(this.node.label).length === 0
            },
            nodeIsHidden() {
                return this.hidden && this.hidden.indexOf(this.node.value) !== -1;
            },
            nodeIsSelected() {
                if (_.isArray(this.selected) && _.isInteger(parseInt(_.head(this.selected)))) {
                    return _.indexOf(this.selected, parseInt(this.node.value)) !== -1;
                }

                try {
                    let selectedObj = JSON.parse(this.selected);
                    let valueObj = JSON.parse(this.node.value);

                    return selectedObj && valueObj && (selectedObj.index == valueObj.index) && (selectedObj.directory == valueObj.directory)
                } catch (e) {
                    // console.log(e);
                }
            },
            displayLabelNoCounts() {
                return this.label || this.node.label;
            },
            displayLabel() {
                let label = this.label || this.node.label;

                if (this.showCounts && this.values && this.values.count > 0) {
                    label += ' (' + this.values.count;

                    if (this.values.size_mb > 0) {
                        label += ' with ' + this.values.size_mb + ' mb';
                    }

                    label += ')';
                }


                return label;
            },
            values() {
                return this.node.value ? JSON.parse(this.node.value) : {};
            },
        },
    }
</script>
<template>
    <li :class="{'jstree-hidden-node': nodeWithoutLabel, 'jstree-open': nodeIsSelected}" :id="node.value" :data-label-without-counts="displayLabelNoCounts"
        v-if="!nodeIsHidden">
        <a :class="{'jstree-clicked': nodeIsSelected}" v-text="displayLabel"></a>
        <ul>
            <tree-node
                    class="droppable"
                    :class="{'jstree-open': !childrenCollapsed}"
                    v-for="child in node.children"
                    :node="child"
                    :children-collapsed="childrenCollapsed"
                    :selected="selected"
                    :hidden="hidden"
                    :show-counts="showCounts"
                    :key="child.key"
            >
            </tree-node>
        </ul>
    </li>
</template>
